import api from "../../api";
import { formatArrayToElSelect } from "./../../utils";

const state = {
  status: "",
  list: [],
  support_sellers: [],
  supportSellersEmployee: []
};

const getters = {
  getSupportSellerSelector: (state) => {
    return formatArrayToElSelect(state.support_sellers, {
      label: "FullName"
    });
  },
  getSupportSellersEmployee: (state) => state.supportSellersEmployee
};

const actions = {
  fetchSupportSellers: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/users/agends", {
          timeout: 3000 * 6 * 1000
        })
        .then((resp) => {
          //console.log("SupportSellers: ",resp)
          commit("success");
          commit("SET_SUPPORT_SELLERS", resp.data);
          resolve(resp.data);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  fetchSupportSellersEmployee: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/users/agendsEmployee", {
          timeout: 3000 * 6 * 1000
        })
        .then((resp) => {
          //console.log("SupportSellersEmployee: ",resp)
          commit("success");
          commit("SET_SUPPORT_SELLERS_EMPLOYEE", resp.data);
          resolve(resp.data);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  }
};

const mutations = {
  loading: (state) => (state.status = "loading"),
  success: (state) => (state.status = "success"),
  error: (state) => (state.status = "error"),
  list: (state, list) => {
    state.list = list;
  },
  SET_SUPPORT_SELLERS: (state, payload) => {
    state.support_sellers = payload;
  },
  SET_SUPPORT_SELLERS_EMPLOYEE: (state, payload) => {
    state.supportSellersEmployee = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
